import { toPlainSchemaValue } from "./toPlainSchemaValue";

// Coerce an interaction's `components` into a plain object whose `strategy` is
// always an array (the backend sometimes sends it object-keyed as {"0":..}).
export function normalizeComponents(interaction: any): Record<string, unknown> {
  const components = (interaction as any)?.components;
  let plain: Record<string, unknown>;
  if (components != null && typeof components === "object") {
    plain = toPlainSchemaValue(components) as Record<string, unknown>;
    const strategy = plain.strategy;
    if (strategy != null && typeof strategy === "object" && !Array.isArray(strategy)) {
      const keys = Object.keys(strategy)
        .filter((k) => /^\d+$/.test(k))
        .sort((a, b) => Number(a) - Number(b));
      if (keys.length > 0) {
        plain.strategy = keys.map((k) => (strategy as Record<string, unknown>)[k]);
      }
    }
    if (!Array.isArray(plain.strategy)) plain.strategy = [];
  } else {
    plain = { strategy: [] };
  }
  return plain;
}
